<template>
  <div id="app">
    <!-- <Slideshow/> -->
    <div class="slideshow">
      <div class="slides">
        <div class="slide">
          <!-- <img src="/assets/img/background.jpg" loading="lazy" alt="picture"> -->
        </div>
      </div>
    </div>
    <div el="layout-hm fixed">
      <header el="header">
        <Nav />
      </header>
      <main el="main">
        <div
          el="list xsm"
          style="margin-top:60px;padding:30px;max-width: 75ch;justify-items: center;"
        >
          <h3
            el
            style="font-weight: 300;text-align: center;letter-spacing: 3.24px;font-size: 30px;"
          >
            CONNECT WITH US!
          </h3>
          <div class="social" el="list-column xxsm" style="align-items: center;">
            <a
              href="https://www.instagram.com/hazelcreates_"
              rel="noopener"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-brand-instagram"
                width="44"
                height="44"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#daa520"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <rect x="4" y="4" width="16" height="16" rx="4" />
                <circle cx="12" cy="12" r="3" />
                <line x1="16.5" y1="7.5" x2="16.5" y2="7.501" />
              </svg>
            </a>
            <a href="mailto:hazel@hccreates.com" rel="noopener">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-mail"
                width="44"
                height="44"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#2c3e50"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <polyline points="3 7 12 13 21 7" />
              </svg>
            </a>
            <a href="tel:7034623138" rel="noopener">
              <svg style="height: 35px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
</svg>

            </a>
          </div>
          <hr el />
          <h3
            el
            style="font-weight: 300;text-align: center;letter-spacing: 3.24px;font-size: 30px;"
          >
            BUSINESS HOURS
          </h3>
          <!-- <table el="table">
                        <thead>
                            <tr>
                                <th>Day(s)</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>TUE-SAT</td>
                                <td>10:00AM - 7:00PM</td>
                            </tr>
                        </tbody>
                    </table> -->
          <!-- <div el="status-warning">
            Due to Covid, appointment only, no walk-ins
          </div> -->
          <p
            el
            style="--color:hsla(0,0%,0%,0.65);max-width:800px;line-height:1.5rem;"
          >
            <b>MON-SAT</b>, 10:00AM - 6:00PM
            <!-- <b>SUN-MON</b>, Closed -->
          </p>
          <hr el />
          <h3
            el
            style="font-weight: 300;text-align: center;letter-spacing: 3.24px;font-size: 30px;margin-top:32px;"
          >
            LOCATION
          </h3>
          <a
            href="https://google.com/maps?q=22114 Gramercy Park Dr Building F Suite 9, Ashburn, VA 20147"
            target="_blank"
            rel="noopener noreferrer"
            class="location"
          >
            <img
              src="../assets/img/kbl-map-small.jpg"
              alt="location"
              loading="lazy"
            />
          </a>
          <p el>22114 Gramercy Park Dr Building F Suite 9, Ashburn, VA 20147</p>

          <!-- <h3
            el
            style="font-weight: 300;text-align: center;letter-spacing: 3.24px;font-size: 30px;margin-top:32px;"
          >
            REFERRAL PROGRAM
          </h3>
          <p el>
            For every 2 color appointment clients you send to us, you receive a
            complimentary haircut, conditioning treatment and style!
          </p> -->

          <h3
            el
            style="font-weight: 300;text-align: center;letter-spacing: 3.24px;font-size: 30px;margin-top:32px;"
          >
            GIFTCARDS
          </h3>
          <p el>
            The best gift you can give someone is one that makes them feel good
            about themself! We offer gift cards for that special someone
            available at your request.
          </p>

          <h3
            el
            style="font-weight: 300;text-align: center;letter-spacing: 3.24px;font-size: 30px;margin-top:32px;"
          >
            POLICIES
          </h3>
          <Accordion title="Cancellations">
            <div el="list sm" style="padding:0 30px 30px;">
              <p el>
                We ask that you provide us with 24 hours of notice of
                cancellation or rescheduling for all appointments. Any no show
                or less than 24 hours notice of cancellation or rescheduling are
                subjected to pay 50% of the service amount. This includes
                changing the service to a significantly smaller service at the
                time of the appointment. If service needs to be altered please
                let your stylist know beforehand so they can adjust their
                schedule accordingly.
              </p>
            </div>
          </Accordion>
          <Accordion title="Appointments">
            <div el="list sm" style="padding:0 30px 30px;">
              <p el>
                We request to arrive on time for scheduled appointments in order
                to receive the full booked service. It is important to us that
                all of our guests’ time is valued.
              </p>
              <p el>
                Large services are subjected to a 50% holding deposit of
                scheduled service to avoid less than 24 hour cancellation and
                time for large time slots to be filled by stylists. The deposit
                of 50% can be refunded if we are given more than 24 hours to
                cancel or reschedule an appointment. Please let your stylist
                know within a 1 week timeframe if for any reason you are not
                satisfied with the service you received from us.
              </p>
            </div>
          </Accordion>
          <Accordion title="Products">
            <div el="list sm" style="padding:0 30px 30px;">
              <p el>
                Please give us a 1 week timeframe to let us know if for any
                reason you are not satisfied with your hair product(s) that are
                purchased.
              </p>
            </div>
          </Accordion>
          <Accordion title="Health Policy" id="covid19">
            <div el="list sm" style="padding:0 30px 30px;">
              <p el>
                Our whole ideology in being in a studio salon is to create a clean, safe, and personalized experience for each guest. Please be mindful of staying healthy and respectful to others when at an appointment. We strive to maintain a comfortable space for everyone! If you are feeling sick or have had exposure to someone sick please contact your stylist. We will gladly work on rescheduling the appointment accordingly.

              </p>
            </div>
          </Accordion>

          <!-- <a href="docs.html" el="btn">Docs</a> -->
          <!-- <h3 el style="font-weight: 300;text-align: center;letter-spacing: 3.24px;font-size: 18px;">ASK A QUESTION</h3>
                        <input type="text" placeholder="Name">
                        <input type="text" placeholder="Email">
                        <textarea name="" id="" cols="30" rows="5" placeholder="Message"></textarea>
                        <div style="display:flex;justify-content:center;">
                            <div el="btn rnd">Send</div>
                        </div> -->
        </div>
      </main>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Nav from "@/components/Nav.vue";
import Accordion from "@/components/Accordion.vue";
// import CovidPolicy from "@/components/CovidPolicy.vue";
// import Slideshow from '@/components/Slideshow.vue'

export default {
  name: "Info",
  components: {
    Nav,
    // CovidPolicy,
    Accordion,
    // Slideshow
  },
};
</script>
<style lang="scss">
@import "../assets/scss/components/vars";

hr[el] {
  --bg-color: hsl(0deg 0% 0% / 25%);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

[el="main"] {
  justify-content: center;
  align-items: center;
  display: grid !important;
}
#main-center {
  justify-content: center;
}
.social svg {
  stroke: #{$color-p1};
}
.location img {
  max-width: 500px;
  height: 300px;
  object-fit: cover;
  object-position: center;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
  // cursor: pointer;
}
</style>
